/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, } from '../../twd/twd'

export const PriceOrYield = ({priceOrYield, setPriceOrYield}) => {
    const id = getId()

    return <React.Fragment>
        <div className="form-group"
            style={{paddingLeft:'0px', paddingRight:'0px'}}
        >
            <label
                className='label'
                htmlFor={id} 
                style={{ lineHeight:'20px', display:'inline', textAlign:'left', marginBottom:0}}
            >Calculate using</label>
            
            <div className="select-wrapper">
            <select
                id={id}
                data-name="calculator-enter-input-action"
                defaultValue={priceOrYield}
                onChange={(e) => setPriceOrYield(e.target.value)}
                className="form-control"
            >
                <option value="1" selected={String(priceOrYield) === '1'}>Price</option>
                <option value="2" selected={String(priceOrYield) === '2'}>YTM</option>
                <option value="0" selected={String(priceOrYield) === '0'}>YTW</option>                
            </select>
            </div>
        </div>
    </React.Fragment>
}
